import { useEffect } from "react";

const CURRENT_VERSION = process.env.REACT_APP_VERSION;

export default function useAutoRefresh() {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch("/version.json", {
          cache: "no-store",
        });

        const data = await response.json();

        if (data.version !== CURRENT_VERSION) {
          window.location.reload(true);
        }
      } catch (err) {
        console.error("Version check failed:", err);
      }
    };

    const interval = setInterval(checkVersion, 30000); 

    return () => clearInterval(interval);
  }, []);
}
